import { render, staticRenderFns } from "./UnsupportedBrowsers.vue?vue&type=template&id=3d20ac1f&scoped=true&"
import script from "./UnsupportedBrowsers.vue?vue&type=script&lang=js&"
export * from "./UnsupportedBrowsers.vue?vue&type=script&lang=js&"
import style0 from "./UnsupportedBrowsers.vue?vue&type=style&index=0&id=3d20ac1f&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d20ac1f",
  null
  
)

export default component.exports